var map = {
	"./music-instructions.json": 4081,
	"./music-library-intro2024.json": 4082,
	"./music-library-launch2024.json": 4083,
	"./music-progression.json": 4084,
	"./startSourcesAdvanced.json": 4085,
	"./startSourcesSimple.json": 4086,
	"./startSourcesSimple2.json": 4087,
	"./startSourcesTracks.json": 4088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3846;